import {
  FormModal,
  FormModalType,
  CheckboxInputField,
  Option,
  SelectInputField,
  useToast,
  noop,
} from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { useStudyProtocolModal } from '../../../../hooks';
import { StudyProcedureRoleDefinition } from '../../../../models';
import {
  addStudyProcedureRoleDefinition,
  modifyStudyProcedureRoleDefinition,
  removeStudyProcedureRoleDefinition,
} from '../../../../redux/actions';

export function StudyProcedureRoleDefinitionModal(props) {
  const {
    existingRoles = [],
    onClose = noop,
    onSuccess = noop,
    studyProcedureRoleDefinition = undefined,
    visible = false,
  } = props;

  // VARIABLES
  const defaultValues = {
    notify: studyProcedureRoleDefinition?.notify || false,
    roleId: studyProcedureRoleDefinition?.role.id,
  };

  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { data: protocol } = useSelector((state) => state.protocolReducer.protocol);
  const { data: roles } = useSelector((state) => state.rolesReducer.roles);
  const { error: actionError, loading } = useSelector((state) => state.protocolReducer.protocolAction);
  // Custom
  const { getCustomErrors, onCloseHandler } = useStudyProtocolModal({ onClose });
  const { showErrorToast, showSuccessToast } = useToast();

  const fields = [
    new SelectInputField({
      disabled: loading,
      id: 'roleId',
      label: 'Role',
      name: 'Role',
      options: roles.filter((role) => !existingRoles.includes(role.id)).map((role) => new Option(role.name, role.id)),
      required: true,
      value: defaultValues.roleId,
    }),
    new CheckboxInputField({
      disabled: loading,
      id: 'notify',
      label: 'Receives Notifications',
      name: 'Receives Notifications',
      value: defaultValues.required,
    }),
  ];

  // METHODS
  const onCreate = (data) => {
    dispatch(
      addStudyProcedureRoleDefinition({
        contributorRoleData: data,
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Contributor Role created successfully');
          onSuccess();
        },
        protocolId: protocol.id,
      }),
    );
  };

  const onUpdate = (data) => {
    dispatch(
      modifyStudyProcedureRoleDefinition({
        contributorRoleData: data,
        id: studyProcedureRoleDefinition.id,
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Contributor Role updated successfully');
          onSuccess();
        },
        protocolId: protocol.id,
      }),
    );
  };

  const onDelete = () => {
    dispatch(
      removeStudyProcedureRoleDefinition({
        id: studyProcedureRoleDefinition.id,
        onError: showErrorToast,
        onSuccess: () => {
          showSuccessToast('Contributor Role removed successfully');
          onSuccess();
        },
        protocolId: protocol.id,
      }),
    );
  };

  return (
    <FormModal
      customErrors={getCustomErrors(actionError)}
      defaultValues={defaultValues}
      deletable={Boolean(studyProcedureRoleDefinition)}
      fields={fields}
      loading={loading}
      onClose={onCloseHandler}
      onCreate={onCreate}
      onDelete={onDelete}
      onUpdate={onUpdate}
      title={studyProcedureRoleDefinition ? 'Update Contributor Role' : 'Add Contributor Role'}
      type={studyProcedureRoleDefinition ? FormModalType.UPDATE : FormModalType.CREATE}
      visible={visible}
    />
  );
}

StudyProcedureRoleDefinitionModal.propTypes = {
  existingRoles: PropTypes.arrayOf(PropTypes.number),
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  studyProcedureRoleDefinition: PropTypes.instanceOf(StudyProcedureRoleDefinition),
  visible: PropTypes.bool,
};

export default StudyProcedureRoleDefinitionModal;
